import React, { Component } from 'react';
import './Entity.css';
import Library from '../utility/Library';
import { Tooltip } from 'reactstrap';
import Img from '../../StableImage';
import { read } from '../../TextManager';

export default class Entity extends Component {

  state = { tooltip: null }

  toggleTooltip (tooltip, touch) {

    if (tooltip === this.state.tooltip && this.state.tooltipDate && new Date() - this.state.tooltipDate < 500)
      return;

    if (touch) {
      
      if (this.tooltipTimeout)
        clearTimeout(this.tooltipTimeout);

      this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip, tooltipDate: new Date()});
      this.tooltipTimeout = setTimeout(() => this.toggleTooltip(null), 3000);
      return;
    }

    this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip});
  }

  intentText (intent) {

    return read('intents/' + intent);
  }

  entityWidth (scale) {

    return scale ? (33.6 * scale) + "vh" : undefined;
  }

  overgrowthScaleBonus (src, statuses) {

    if (src.getStatusValue)
      return src.getStatusValue("overgrowth") * 0.03;

    const overgrowth = statuses.find(status => status.model.key === "overgrowth");
    return overgrowth ? overgrowth.value * 0.03 : 0;
  }

  intentVars (src, scale) {

    if (!scale && src.id !== "companion")
      return {};

    let top = -6;
    let shortTop = -7.4;

    if (src.id === "companion" || scale < 0.9) {
      top = 1.2;
      shortTop = -0.2;
    }
    else if (scale >= 1.5) {
      top = -14;
      shortTop = -14.4;
    }
    else if (scale >= 1.15) {
      top = -12;
      shortTop = -13.4;
    }

    return {
      "--intent-top": top + "vh",
      "--intent-top-end": (top - 1.2) + "vh",
      "--intent-short-top": shortTop + "vh",
      "--intent-short-top-end": (shortTop - 1.2) + "vh"
    };
  }

  render () {

    let src = this.props.src;

    let statuses = src.statuses || [];

    let intent = src.intent || this.props.intent;

    let compute = intent && src.compute && src.compute(src.nointent).type ? src.compute(src.nointent).value : undefined;

    let invincibility = statuses.filter(s => s.model.key === "invincibility").length > 0;

    let scale = this.props.scale || src.scale;

    if (!scale && src.model && src.model.scale)
      scale = src.model.scale;

    if (!scale && src.id?.type === "enemy")
      scale = 1;

    if (!scale && src.id?.type === "fountain")
      scale = 1.25;

    const overgrowthScaleBonus = this.overgrowthScaleBonus(src, statuses);
    if (overgrowthScaleBonus)
      scale = (scale || 1) + overgrowthScaleBonus;

    let down = src.down || 0;
    let left = src.left || 0;
    let bottom = src.bottom || 0;

    let key = src.id?.no || src.key;
    if (!src.action && (src.champion || src.level))
      key = "player";

    let idno = null;
    if (src.id) {
      idno = src.id.no;
      if (idno === undefined)
        idno = src.id;
    }

    let imgAnimation = "";
    if (src.hasStatus && src.hasStatus('momentum'))
      imgAnimation += " game-entity-animation-momentum";

    const layoutScale = this.props.layoutScale === undefined ? scale : this.props.layoutScale;
    let entityWidth = this.entityWidth(layoutScale);
    let scaledWidth = entityWidth ? { width: entityWidth } : undefined;
    
    return (
      <div
        key={"game-entity-" + (key === "player" ? "player" : key)}
        id={"game-entity-" + (key === "player" ? "player" : key)}
        className={"game-entity " + (src.name ? "game-entity-" + src.name + " " : "") + (this.props.static || src.passive ? "game-entity-static " : "") + (statuses.reduce((acc, e) => acc + "status-" + e.model.name.toLowerCase() + " ", "")) + imgAnimation}
        style={Object.assign({}, this.intentVars(src, scale), scaledWidth)}
        >
        <div className="game-entity-main-wrapper">
          <div className="game-entity-main">
            <div className={"game-entity-img-wrapper"}
                onClick={e => { this.props.onSelect(e, src); }}
                style={Object.assign(scale ? {height: (33.6 * scale) + "vh", left: left + "vh", marginTop: (33.6 - 31.6 * scale - 2) + "vh"} : {}, bottom ? {marginBottom: (bottom) + "vh"} : {})}
                >
              {
                src.id?.type === "fountain" ?
                <div className="game-entity-main-img"/> :
                <Img id={"game-entity-" + (key === "player" ? "player" : key) + "-img"} key={src.id + "-entity-" + src.img} className="game-entity-main-img" src={src.img}/>
              }
              <Img key={src.id + "-entity-" + src.img + "-afterimage"} className="game-entity-afterimage" src={src.img}/>
              {!src.shadowless && <div className="game-entity-shadow"
                style={scale ? {height: (7.2 * scale * 0.9) + "vh", width: (24 * scale * 0.9) + "vh", left: (4.8 * scale * 1.2) + "vh", bottom: (-2.4+down) + "vh"} : {bottom: (-2.4+down) + "vh"}}
                />}
              <div className="game-entity-animation-space">
                <div className="game-entity-animation-object animation-object-1"/>
                <div className="game-entity-animation-object animation-object-2"/>
                <div className="game-entity-animation-object animation-object-3"/>
                <div className="game-entity-animation-object animation-object-4"/>
                <div className="game-entity-animation-object animation-object-5"/>
              </div>
              <div className="game-entity-afflict-status">
                <Img className="game-entity-afflict-status-img" src="/images/nothing.png"/>
                <div className="game-entity-afflict-status-text"></div>
              </div>
              <div className="game-entity-afflict-status">
                <Img className="game-entity-afflict-status-img" src="/images/nothing.png"/>
                <div className="game-entity-afflict-status-text"></div>
              </div>
              <div className="game-entity-damage"></div>
              <div className="game-entity-damage"></div>
            </div>
            {
              intent ?
              <div id={"entity-" + idno + "-intent"} onPointerDown={e => this.toggleTooltip(idno + "-intent", e.pointerType === "touch")} className="game-entity-intent">
                { typeof intent.type === "string" ? "" : <img className="game-entity-intent-img" src={"/images/intents/" + intent.type[1] + ".png"}/> }
                { typeof intent.type === "string" ? "" : <img className="game-entity-intent-img intent-anim-img" src={"/images/intents/" + intent.type[1] + ".png"}/> }
                { typeof intent.type === "string" ? "" : <img className="game-entity-intent-img intent-anim-img" src={"/images/intents/" + intent.type[1] + ".png"}/> }
                <img className="game-entity-intent-img" src={"/images/intents/" + (typeof intent.type === "string" ? intent.type : intent.type[0]) + ".png"}/>
                <img className="game-entity-intent-img intent-anim-img" src={"/images/intents/" + (typeof intent.type === "string" ? intent.type : intent.type[0]) + ".png"}/>
                <img className="game-entity-intent-img intent-anim-img" src={"/images/intents/" + (typeof intent.type === "string" ? intent.type : intent.type[0]) + ".png"}/>
                { intent.damage !== undefined ? <div className="game-entity-intent-text">{ src.id === "companion" ? intent.damage : src.master.player.modifyDamageIn(compute !== undefined ? compute : intent.damage, src) }{ (intent.times ? <span className="intent-times">{"x" + intent.times}</span> : "") }</div> : "" }
              </div> : ""
            }
            { 
              intent ? <Tooltip className="tooltip" placement="top" isOpen={this.state.tooltip === idno + "-intent"} target={"entity-" + idno + "-intent"} toggle={() => this.toggleTooltip(idno + "-intent")}>
              {(() => {
                return read('intents/start1') + (src.id === "companion" ? read('intents/companion') : read('intents/enemy')) + read('intents/start2') + (typeof intent.type === "string" ? this.intentText(intent.type) : this.intentText(intent.type[0]) + read('intents/and') + this.intentText(intent.type[1])) + read('intents/end');
              })()}
              </Tooltip> : ""
            }
            <div className="game-entity-dialog"></div>
            <div className="game-entity-name">{src.name || src.model.name}</div>
          </div>
          <div className="game-entity-particles">
            <div className="particle"/><div className="particle"/><div className="particle"/><div className="particle"/><div className="particle"/>
            <div className="particle"/><div className="particle"/><div className="particle"/><div className="particle"/><div className="particle"/>
            <div className="particle"/><div className="particle"/><div className="particle"/><div className="particle"/><div className="particle"/>
            <div className="particle"/><div className="particle"/><div className="particle"/><div className="particle"/><div className="particle"/>
          </div>
        </div>
        {
          src.maxhp !== undefined && !src.passive ?
          <div className="game-entity-life-wrapper"
          style={scaledWidth}
          >
          {
            src.block > 0 || invincibility ?
            <div className="game-entity-block">
              <Img className="game-entity-block-img" src={invincibility ? "/images/statuses/Invincibility.png" : "/images/block.png"}/>
              { invincibility ? "" : <div className="game-entity-block-text">{src.block}</div> }
            </div> : ""
          }
            <div className="game-entity-life-text"
          style={scaledWidth}>
              {src.hp}/{src.maxhp}
            </div>
            <div className={"game-entity-life " + (invincibility ? "invincibility " : (src.block > 0 ? "block" : this.props.lifeColor || ""))}
          style={scaledWidth}>
              <div className="game-entity-life-fill" style={{width: (100 * src.hp / src.maxhp) + "%"}}>
              { src.hasStatus && src.hasStatus("poison") && <div className="game-entity-life-fill poison" style={{width: "calc(1px + " + (100 * src.getStatusValue("poison") / src.hp) + "%)"}}/> }
              </div>
            </div>
          </div> : ""
        }
        <div className="game-entity-statuses"
          style={scaledWidth}>
        {
          statuses.length > 0 ? statuses.filter(status => !status.model.invisible).map((status,i) =>
            <div id={"status-" + status.key} key={status.key} className={"game-entity-status-wrapper" + (key === "player" && src.model.key === 2 && status.model.key === "tension" ? " hidden-ruby-tension" : "")}>
              <div className="game-entity-status" onPointerDown={e => this.toggleTooltip(status.key + "-status", e.pointerType === "touch")}>
                <Img className="game-entity-status-img" src={"/images/statuses/" + status.model.translations.en.name + ".png"}/>
                { !status.model.unstackable && status.model.countable !== false && <div className="game-entity-status-text">{status.value}</div> }
              </div>
              <Tooltip className="tooltip" placement="top" isOpen={this.state.tooltip === status.key + "-status"} target={"status-" + status.key} toggle={() => this.toggleTooltip(status.key + "-status")}><b>{ status.model.name }</b><br/>{ status.model.effect }</Tooltip>
            </div>
          ) : <div key="0" className="game-entity-status-wrapper"/>
        }
        </div>
      </div>
    );
  }
}

